module.exports = __webpack_public_path__ + "media/src/images/landing/adafruit-compact-256-c164befb381ecf49c07e8b058f6894e6.png";